module.exports = __webpack_public_path__ + "img/logo.212d4e59.png";